import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyCNiyxjqMCUc5FTw67auFLlg21bc9sUPn0',
  authDomain: 'pixano-ff250.firebaseapp.com',
  projectId: 'pixano-ff250',
  storageBucket: 'pixano-ff250.firebasestorage.app',
  messagingSenderId: '382468789089',
  appId: '1:382468789089:web:0082f028873934a4e12b20',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');
